export default __webpack_public_path__ + "static/media/styled_components.3ecd6b62.svg";